<template>
    <div class='form-group row'>
        <label class='col-sm-3 col-md-3 col-lg-3 col-form-label'>
          Seleccione la estación
        </label>
        <div class='col-sm-9 col-md-9 col-ls-9'>
            <select
              class="form-select"
              name='station'
              id='station'
              @change='emitId()'
              v-model='target'
              ref="selected"
            >
              <option
              value="" disabled
              >
                {{defaultValue}}
              </option>
              <option
               v-for="station in stations"
               :key="station.id"
               :value="station.id"
              >
                {{station.name}}
              </option>
            </select>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import listHydrologicalStations from '../../services/hydrologicalStations'

export default {
  data () {
    return {
      defaultValue: 'Seleccione una estación',
      target: '',
      stations: [],
      station_name: '',
    }
  },
  created(){
    switch (this.typology) {
      case 'hydrometeorological':
      this.stations = this.HydroclimatologicalStations
      break;
      case 'groundWater':
      this.stations = this.groundWaterStations
      break;
      case 'airQuality':
      this.stations = this.airQualityStations
      break;
      case 'hydrological':
      this.stations = listHydrologicalStations.hydrologicalStations
      break;
    }
  },

  inject: ['typology'],

  computed: {
    ...mapState(['HydroclimatologicalStations', 'groundWaterStations', 'airQualityStations', 'minDate', 'maxDate'])
  },
  methods: {
    ...mapActions(['getDataDatesForStation', 'Change_Id', 'Change_Name_Station', 'getNameStationById', 'Change_Typology']),

    emitId(){
      const changeDataTypology = {
        station_id: this.$refs.selected.value,
        typology: this.typology === 'hydrological' ? 'hydrometeorological' : this.typology
      }
      this.getDataDatesForStation(changeDataTypology)
      this.Change_Id(this.$refs.selected.value)
      this.Change_Name_Station(this.target.name)
      this.getNameStationById({
        station_sk: this.$refs.selected.value
      })
      this.Change_Typology(this.typology)
    }
  },
}
</script>

<style scoped>
.form-select{
  margin-top: 0.75rem;
  height: 2.5rem;
}
.form-select::-webkit-scrollbar {
  display: none;
}

.form-group {
  margin-bottom: 1.5rem;
}

.col-form-label {
  font-family: "Ancizar-regular", Helvetica, Arial;
}

.form-control, option {
  font-family: "Ancizar-light", Helvetica, Arial;
}

@media (max-width: 769px) {
  .col-form-label,
  .col-sm-9 {
    width: 100% !important;
  }
}

</style>